import React from "react";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { FolderIcon } from "@common/folderIcon";
import { ZoneAvatar } from "@common/zoneAvatar";

import { sanitize } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Project({ query, args }: Props) {
  const { pushView } = useModal();

  return (
    <div
      className={styles.project}
      onClick={() =>
        pushView({
          key: UseCases.retrieveProject,
          data: { project: args, isMultiProject: true },
        })
      }
    >
      <FolderIcon className={styles.icon} />
      {/*<div className={styles.zone}>*/}
      {/*  <ZoneAvatar {...args.zone} />*/}
      {/*</div>*/}
      <p
        className={styles.name}
        dangerouslySetInnerHTML={{
          __html: args.name.replace(
            new RegExp(sanitize(query.name), "ig"),
            `<span class="${styles.match}">${query.name}</span>`,
          ),
        }}
      />
    </div>
  );
}

export { Project };
